// redux
import { combineReducers } from "redux"
// app
import profiles, { fetching as profilesFetching, error as profilesError }  from "actions/profiles/reducer.js"
import profile, { fetching as profileFetching, error as profileError } from "actions/profile/reducer.js"
import user, { fetching as userFetching, error as userError } from "actions/user/reducer.js"
import search, { fetching as searchFetching, error as searchError } from "actions/search/reducer.js"
import ref, { fetching as refFetching } from "actions/ref/reducer.js"
import exportr, { fetching as exportFetching, error as exportError } from "actions/export/reducer.js"


export function fetching(state) {
    if (!state) return false
    return profileFetching(state.profile) ||
        profilesFetching(state.persons) ||
        refFetching(state.ref) ||
        userFetching(state.user) ||
        searchFetching(state.search) ||
        exportFetching(state.export)
}

export function error(state) {
    if (!state) return false

    // profile
    const p = profileError(state.profile)
    if (p !== false) return p
    // user
    const u = userError(state.user)
    if (u !== false) return u
    // profiles
    const pp = profilesError(state.profiles)
    if (pp !== false) return pp
    // search
    const s = searchError(state.search)
    if (s !== false) return s
    // export
    const e = exportError(state.export)
    if (e !== false) return e
    
    return false
}

export default combineReducers({
    profiles,
    profile,
    user,
    ref,
    search,
    export: exportr
})


/** WEBPACK FOOTER **
 ** ./src/reducer.js
 **/